<info_log_area>

    <div class="com-works__item__inner" last_item={props.last_item}>
        <dl>
            <dt style="">
                { formatDate(props.info_log.log_time) }  {props.info_log.title}
            </dt>
            <dd style="padding-left:0em;font-size: 1.6rem;">
                <div class="infomation_thumb_block" if={props.info_log.image_path != ""}>
                    <img src={props.info_log.image_path} >
                </div>

                <div>
                    <common_article_non_escape_html html={props.info_log.body}></common_article_non_escape_html>
                </div>

            </dd>
        </dl>
    </div>


    <script>

        import di from 'dependeny-injection'
        import common_article_non_escape_html from './../../../../common/tags/page_object/common_page_object_non_escape_html.riot'
        import dayjs from 'dayjs'

        export default {
            components: {
                common_article_non_escape_html: common_article_non_escape_html
            },
            state:{

            },
            formatDate(log_time){
                return dayjs(log_time * 1000).format("YYYY-MM-DD");
            },
            onMounted(){

                let my = this;
                di.info_log.get().then(function (data) {

                    if(data.info_logs.length >= 1){
                        my.state.info_logs = [ data.info_logs[0] ];
                    }

                    my.update();
                });
            },
        }
    </script>
</info_log_area>